import { Action, createReducer, on } from '@ngrx/store';
import { ForceOrganisationDocument } from '../models';
import { clearForceOrganisation, setFolders, setForceOrganisation, setItems, setViewMode } from './actions';

export interface ForceOrganisationState {
    [gameId: string]: ForceOrganisationDocument | null;
}

export const initialForceOrganisationState: ForceOrganisationState = {};

const reducer = createReducer(
    initialForceOrganisationState,
    on(setForceOrganisation, (state, { doc }) => ({
        ...state,
        [doc.gameId]: { ...doc }
    })),
    on(clearForceOrganisation, () => ({})),
    on(setViewMode, (state, { gameId, mode }) => {
        const existing = state[gameId];
        if (!existing) return state;
        return { ...state, [gameId]: { ...existing, viewMode: mode } };
    }),
    on(setFolders, (state, { gameId, folders }) => {
        const existing = state[gameId];
        if (!existing) return state;
        return { ...state, [gameId]: { ...existing, folders: [...folders] } };
    }),
    on(setItems, (state, { gameId, items }) => {
        const existing = state[gameId];
        if (!existing) return state;
        return { ...state, [gameId]: { ...existing, items: [...items] } };
    })
);

export function forceOrganisationReducer(state: ForceOrganisationState | undefined, action: Action) {
    return reducer(state, action);
}
